import { useMemo } from 'react'

import type { IconRegistryItem, VectorIcon } from '@microservices/wiskey-react-components'
import { ICON_REGISTRY } from '@mobileConstants'


type VectorIconRendererProps = {
  icon: VectorIcon | null | undefined
  iconRegistry?: IconRegistryItem[]
}

export const VectorIconRenderer = ({ icon, iconRegistry = ICON_REGISTRY }: VectorIconRendererProps) => {
  const registryItem = useMemo(() => {
    if (!icon) return null

    return (
      iconRegistry.find(item => item.library === icon.type && item.id === icon.value) ?? null
    )
  }, [icon, iconRegistry])

  if (!icon || !registryItem) return null

  return <registryItem.Component size={icon.size} color={icon.color} />
}

